import script from "./goRinSyo0010.vue?vue&type=script&setup=true&lang=js"
export * from "./goRinSyo0010.vue?vue&type=script&setup=true&lang=js"

import "./goRinSyo0010.vue?vue&type=style&index=0&id=87232122&lang=scss"

const __exports__ = script;

export default __exports__